<main class="container" aria-label="Best modernization candidates from code validation">
  <section id="column">
    <div class="row">
      <div class="col col-12">
        <div class="d-flex align-items-center mb-3">
          <div class="flex-grow-1 flex-basis-0">
            <button class="btn btn-sm btn-outline-secondary btn-back" (click)="backToDashboard()">Back</button>
          </div>
          <h1 class="applications-title mb-0 text-center flex-shrink-0">
            Code Validation Candidates<br />
            <small>Applications where CMDB and source-code validation disagree</small>
          </h1>
          <div class="flex-grow-1 flex-basis-0 candidate-count">{{ total }} candidates</div>
        </div>

      @if (loadFailed) {
      <div class="load-error" role="alert">Candidates could not be loaded. Please try again.</div>
      } @else {
        <div class="data-grid-wrapper">
          <app-data-grid [columns]="displayedColumns" [data]="candidates" [actions]="gridActions"
            [config]="dataGridConfig" [loading]="loading" [filtersLoaded]="filtersLoaded"
            (actionClicked)="onGridAction($event)">
          </app-data-grid>
        </div>
      }
      </div>
    </div>
  </section>
</main>

<ng-template #applicationTemplate let-app>
  <div class="application-cell">
    <strong>{{ app.name || 'Unnamed application' }}</strong>
  </div>
</ng-template>

<ng-template #conflictTemplate let-app>
  <div class="conflict-flow">
    <span class="cmdb-result">{{ app.cmdbOutcome || 'Not classified' }}</span>
    <span class="conflict-arrow" aria-hidden="true">→</span>
    <span class="legacy-result">Legacy found</span>
  </div>
</ng-template>

<ng-template #signalsTemplate let-app>
  @if ((app.repositoryLegacySignals || []).length > 0) {
    <div class="repository-list">
      @for (repository of (app.repositoryLegacySignals || []); track repository.repositoryUrl) {
        <div class="repository-signals">
          @for (signal of (repository.signals || []); track signal) {
            <span class="legacy-signal">{{ signal }}</span>
          }
        </div>
      }
    </div>
  } @else {
    <span class="no-signals">Legacy signal details are unavailable.</span>
  }
</ng-template>

<ng-template #readinessTemplate let-app>
  <div class="readiness-cell">
    <span class="readiness-score" [class.unavailable]="app.lightweightCodeAssessmentScore == null">
      {{ app.lightweightCodeAssessmentScore ?? '—' }}@if (app.lightweightCodeAssessmentScore != null) {<small>/100</small>}
    </span>
    @if (recommendedNextStep(app); as nextStep) {
      <span class="next-step">{{ nextStep }}</span>
    }
  </div>
</ng-template>
